import { Injectable, Inject } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
} from "@angular/common/http";
import { map } from "rxjs/operators";
import { DataService } from "../services/data.service";

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  token: any;

  constructor(
    private http: HttpClient,
    private _data: DataService,
    @Inject("API_URL") public API_URL: any
  ) {
    this.token = this._data.getCookiesByName("master_token");
    console.log(this.token);
  }

  activateTrial() {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/subscribe/trial`, null)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getStandardPlans() {
    return this.http
      .get<any>(`${this.API_URL}/usersubscription/standardplan`)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getStandardServices() {
    return this.http.get<any>(`${this.API_URL}/standardservice/service`).pipe(
      map(res => {
        return res;
      })
    );
  }

  processPayment(planObj) {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/subscribe`, planObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  redeemCoupon(redeemObj) {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/redeem`, redeemObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  redeemCouponV2(redeemObj) {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/redeem/v2`, redeemObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  processPayAsGoPayment(paymentObj) {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/payasyougo/v2`, paymentObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  processSubscriptionPayment(paymentObj) {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/subscribe/v2`, paymentObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }
  processPayAsGoPaymentV2Add(paymentObj){
    return this.http.post<any>(`${this.API_URL}/payment/v2/payasyougo/buy` , paymentObj)
      .pipe(map(res => {
        return res;
      }));
  }
  processPayAsGoPaymentV2Update(paymentObj){
    return this.http.post<any>(`${this.API_URL}/payment/v2/payasyougo/buy` , paymentObj)
      .pipe(map(res => {
        return res;
      }));
  }
  processSubscriptionPaymentV2Add(paymentObj){
    return this.http.post<any>(`${this.API_URL}/payment/v2/subscribe` , paymentObj)
      .pipe(map(res => {
        return res;
      }));
  }
  processSubscriptionPaymentV2Update(paymentObj){
    return this.http.put<any>(`${this.API_URL}/payment/v2/subscribe` , paymentObj)
      .pipe(map(res => {
        return res;
      }));
  }
  processTrialSubscriptionPayment(paymentObj){
    return this.http.post<any>(`${this.API_URL}/payment/v2/subscribe/trail` , paymentObj)
      .pipe(map(res => {
        return res;
      }));
  }
  applyTax(obj) {
    return this.http.post<any>(`${this.API_URL}/tax/calculate `, obj).pipe(
      map(res => {
        return res;
      })
    );
  }

  preVerifyPayment(paymentObj) {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/preverification`, paymentObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  //get payment address
  getPaymentAddress() {
    return this.http
      .get<any>(`${this.API_URL}/usersubscription/paymentaddress/`)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  //post payment address
  postPaymentAddress(addressObj) {
    return this.http
      .post<any>(`${this.API_URL}/usersubscription/paymentaddress/`, addressObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }
    
  preVerifyPaymentV2(paymentObj){
    return this.http.post<any>(`${this.API_URL}/payment/v2/preverify` , paymentObj)
      .pipe(map(res => {
        return res;
      }));
  }
  getCurrentSubscription(){
    return this.http.get<any>(`${this.API_URL}/payment/v2/subscribe`)
      .pipe(map(res => {
        return res;
      }));
  }
  processInvoicePayment(paymentObj){
    return this.http.post<any>(`${this.API_URL}/payment/v2/payinvoice` , paymentObj)
      .pipe(map(res => {
        return res;
      }));
  }
  //update payment address
  updatePaymentAddress(addressObj) {
    return this.http
      .put<any>(`${this.API_URL}/usersubscription/paymentaddress/`, addressObj)
      .pipe(
        map(res => {
          return res;
        })
      );
  }
}
